<script lang="ts" setup>
const route = useRoute()
const { isLogged } = storeToRefs(useUser())
const userId = route.params.userId as string | null
const { $switchRoute } = useI18n()
if (userId && !isLogged.value) {
  const { data: user } = await useFetch('/api/auth/check-user', { method: 'POST', body: { userId } })
  if (user.value) {
    const cookie = useCookie('bitbeli-invitedByUserId', {
      maxAge: 60 * 60 * 24 * 90,
    })

    cookie.value = userId
  }
}

$switchRoute('/')
</script>
